import axios from 'axios';
import { BASE_URL } from '../Constants/Api';

const API_URL = BASE_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
export const getEmployees = async (filters = {}) => {
  try {
    // Destructure pagination parameters but keep other filters
    const { page, size, ...otherFilters } = filters;
    
    const params = {
      ...(page !== undefined ? { page } : {}),
      ...(size !== undefined ? { size } : {}),
      ...otherFilters
    };
    
    const response = await api.get("/sales/manageemployee", { params });
    
    // Return the full response data for pagination metadata
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addEmployee = async (employeeData) => {
  try {
    const response = await api.post("/sales/manageemployee", employeeData);
    return response.data;
  } catch (error) {
    throw new Error("Failed to add employee");
  }
};
export const getEmployeeById = async (id) => {
    const response = await api.get(`/sales/manageemployee/${id}`);
    return response.data;
};

export const updateEmployee = async (id, employeeData) => {
  try {
    const response = await api.put(`/sales/manageemployee/${id}`, employeeData);
    return response.data;
  } catch (error) {
    throw new Error("Failed to update employee");
  }
};

export const getbgCheck = async (id) => {
  try {
    const response = await api.get(`/sales/manageemployee/${id}/background-check`);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch background check data");
  }
};
export const getEmployeeByCompany = async (company = "UNISOFT") => {
  try {
    const response = await api.get(`/sales/manageemployee`, {
      params: { company },
    });
    return response.data.content || []; // adjust if needed based on response structure
  } catch (error) {
    return [];
  }
};

export const getEmployeeNamesByCompany = async (company = "UNISOFT") => {
  try {
    const response = await api.get(`/sales/manageemployee/names`, {
      params: { company },
    });
    return response.data || []; // adjust if needed based on response structure
  } catch (error) {
    return [];
  }
};
